module.exports = __webpack_public_path__ + "img/selected5-min.dd47ae94.png";